import { render, staticRenderFns } from "./StoreActivityContent.vue?vue&type=template&id=18d4b546&scoped=true&"
import script from "./StoreActivityContent.vue?vue&type=script&lang=js&"
export * from "./StoreActivityContent.vue?vue&type=script&lang=js&"
import style0 from "./StoreActivityContent.vue?vue&type=style&index=0&id=18d4b546&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4b546",
  null
  
)

export default component.exports